import { render, staticRenderFns } from "./AnalyticalTopproducts.vue?vue&type=template&id=5c05323c&scoped=true"
import script from "./AnalyticalTopproducts.vue?vue&type=script&lang=js"
export * from "./AnalyticalTopproducts.vue?vue&type=script&lang=js"
import style0 from "./AnalyticalTopproducts.vue?vue&type=style&index=0&id=5c05323c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c05323c",
  null
  
)

export default component.exports